import { useEffect, useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import AutoresponderData from "./AutoresponderData";
import EmailTemplates from "./EmailTemplates";

export default ({ loadTemplate }) => {
  const [previewOpened, setPreviewOpened] = useState(false);
  const [previewing, setPreviewing] = useState(null);

  // Fetch data
  const EMAIL_TEMPLATES_DATA = gql`
    query GetEmailTemplatesData {
      emailTemplatesData {
        id
        name
        preview_image
        design
        html
      }
    }
  `;

  const { data, error } = useQuery(EMAIL_TEMPLATES_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching email templates data", error);
    captureException(error);
  }

  // handle Open preview
  const onOpenPreviewClick = (id) => {
    setPreviewOpened(true);
    setPreviewing(id);
  };

  const closePreview = () => {
    setPreviewOpened(false);
    setPreviewing(null);
  };

  console.log("data", data);

  return (
    <>
      {!data && <BoxLoadingSpinner height="280px" />}
      {data && (
        <EmailTemplates
          data={data}
          onOpenPreviewClick={onOpenPreviewClick}
          previewOpened={previewOpened}
          closePreview={closePreview}
          previewing={previewing}
          loadTemplate={loadTemplate}
        />
      )}
    </>
  );
};
